import gql from 'graphql-tag';

export const saveContractorReview = gql`
  mutation ($contractorReviewInput: ContractorReviewInput!, $contractorReviewId: String) {
    saveContractorReview(contractorReview: $contractorReviewInput, contractorReviewId: $contractorReviewId) 
    {
      id
      review
      applicationid
      contractorid
      response
      responseDate
    }
  }
`;
export const saveContractorReviewResponse = gql`
  mutation ($contractorReviewResponseInput: ContractorReviewInput!, $contractorReviewId: String) {
    saveContractorReviewResponse(contractorReview: $contractorReviewResponseInput, contractorReviewId: $contractorReviewId) 
    {
      id
      review
      applicationid
      contractorid
      response
      responseDate
    }
  }
`;